module.exports = __webpack_public_path__ + "img/giaCertificate.a22cd32.webp";